import React, { useEffect, useRef } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Permet aux appelants de masquer aussi ce qui entoure le bouton (séparateur « ou »),
// sinon on affiche un séparateur au-dessus du vide quand le client ID est absent.
export const googleEnabled = Boolean(CLIENT_ID);

// Bouton "Se connecter avec Google" (Google Identity Services). Absent si pas de client ID
// (même convention que REACT_APP_SENTRY_DSN : désactivé sans casser le reste).
function GoogleButton({ onCredential, text = 'continue_with' }) {
  const ref = useRef(null);
  // ponytail: le parent redéfinit onCredential à chaque frappe clavier ; sans ce ref
  // l'effet se rejouerait et Google redessinerait son bouton à chaque caractère saisi.
  const cbRef = useRef(onCredential);
  cbRef.current = onCredential;

  useEffect(() => {
    if (!CLIENT_ID || !ref.current) return;
    let tries = 0;
    // ponytail: le script GIS est async, on attend qu'il soit chargé (abandon après ~5s)
    const iv = setInterval(() => {
      tries++;
      if (window.google?.accounts?.id) {
        clearInterval(iv);
        window.google.accounts.id.initialize({ client_id: CLIENT_ID, callback: r => cbRef.current(r.credential) });
        window.google.accounts.id.renderButton(ref.current, {
          theme: 'outline', size: 'large', text, width: ref.current.offsetWidth || 300,
        });
      } else if (tries >= 50) {
        clearInterval(iv);
      }
    }, 100);
    return () => clearInterval(iv);
  }, [text]);

  if (!CLIENT_ID) return null;
  return <div ref={ref} style={{ width: '100%', display: 'flex', justifyContent: 'center' }} />;
}

export default GoogleButton;
